import "../../styles/Various.css"

import React, { useEffect } from "react"

import EsperienzeSearch from "./EsperienzeSearch"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Helmet } from "react-helmet-async"
import { Link } from "react-router-dom"
import { faArrowRight } from "@fortawesome/free-solid-svg-icons"
import seedEsperienze from "../../data/seedEsperienze"

const EsperienzeIndex = () => {
  useEffect(() => {
    document.title = "Esperienze - IRIS Ambiente"
  }, [])

  return (
    <div className="px-md-0 px-1">
      <Helmet>
        <meta
          name="description"
          content="Esplora le nostre esperienze di ingegneria naturalistica, energia rinnovabile, ecoturismo e formazione. Oltre 30 anni di progetti e studi per enti pubblici e privati."
        />
      </Helmet>

      <section className="bg-light py-5 rounded">
        <div>
          <div className="row">
            <div className="col-12">
              <h1 className="display-4 text-center mb-3">
                Le Nostre Esperienze
              </h1>
              <p className="lead text-center text-muted mb-0">
                Oltre 30 anni di progetti e studi in ingegneria naturalistica,
                energia sostenibile, ecoturismo e formazione ambientale
              </p>
            </div>
          </div>
        </div>
      </section>

      <div className=" py-5">
        <EsperienzeSearch />

        <section className="mt-5">
          <h2 className="mb-4">Esplora per Categoria</h2>
          <div className="row g-4">
            {seedEsperienze.map((categoria) => (
              <div key={categoria.id} className="col-lg-6 col-xl-4">
                <div className="card h-100 shadow-sm hover-card">
                  <img
                    src={require(`../../img/esperienze/${categoria.id}/cover.jpg`)}
                    alt={`Cover ${categoria.title}`}
                    className="card-img-top"
                  />
                  <div className="card-body d-flex flex-column">
                    <h5 className="card-title text-primary">
                      {categoria.title}
                    </h5>
                    <p className="card-text text-muted flex-grow-1">
                      {categoria.subtitle}
                    </p>
                    <div className="mt-3">
                      <div className="row g-2">
                        {categoria.imgs.slice(0, 4).map((img, index) => (
                          <div key={index} className="col-6">
                            <Link
                              to={img.link}
                              className="d-block text-decoration-none"
                              title={img.name}
                            >
                              <div className="bg-light rounded p-2 text-center small hover-bg-primary">
                                <div className="text-truncate">{img.name}</div>
                              </div>
                            </Link>
                          </div>
                        ))}
                      </div>
                      {categoria.imgs.length > 4 && (
                        <div className="text-center mt-2">
                          <small className="text-muted">
                            +{categoria.imgs.length - 4} altri progetti
                          </small>
                        </div>
                      )}
                    </div>
                    <div className="mt-3 pt-3 border-top">
                      <Link
                        to={`/esperienze/${categoria.id}`}
                        className="btn btn-outline-primary w-100"
                      >
                        Esplora {categoria.title}
                        <FontAwesomeIcon icon={faArrowRight} className="ms-2" />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="mt-5 py-5 bg-light rounded">
          <div>
            <h3 className="text-center mb-4">I Nostri Numeri</h3>
            <div className="row text-center">
              <div className="col-md-3 mb-3">
                <div className="display-6 text-primary fw-bold">30+</div>
                <div className="text-muted">Anni di Esperienza</div>
              </div>
              <div className="col-md-3 mb-3">
                <div className="display-6 text-primary fw-bold">350+</div>
                <div className="text-muted">Clienti Serviti</div>
              </div>
              <div className="col-md-3 mb-3">
                <div className="display-6 text-primary fw-bold">200+</div>
                <div className="text-muted">Partner Network</div>
              </div>
              <div className="col-md-3 mb-3">
                <div className="display-6 text-primary fw-bold">5</div>
                <div className="text-muted">Settori Specializzati</div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  )
}

export default EsperienzeIndex
